const ERROR_MESSAGE = {
	required: 'Campo obligatorio.',
	docRequired: 'Documento obligatorio.',
	docInvalidBinary: 'Introduzca un documento con su extensión real.',
	docInvalidLength: 'El nombre del documento no debe superar los 200 caracteres.',
	docMaxSize: 'El peso máximo de los documentos no puede superar los 100MB.',
	nacionalidadRequired: 'La nacionalidad es obligatoria para los pasaportes.',
	docIdentNoValidFormat: 'El formato para el documento de identidad especificado es incorrecto.',
	docIdentNoValid: 'Documento de identidad especificado es incorrecto.',
	codPostalMin: 'Mínimo 5 carácteres.',
	codPostalNoValido: 'Código Postal no válido.',
	emailNoValido: 'Email no válido.',
	telefonoNoValido: 'Teléfono no válido.',
	minInterviniente: 'Se ha de introducir al menos un interviniente.',
	intervinienteConRepresentante: 'Persona jurídica sin representante indicado.',
	duplicatedFisica: 'Ya existe una persona física con el mismo documento para el tipo de intervención seleccionado.',
	intervinienteUnico: 'El número de documento no puede repetirse entre los intervinientes.',
	duplicatedJuridico: 'Ya existe una persona jurídica con el mismo documento para el tipo de intervención seleccionado.',
	duplicatedRepresentante: 'Existen varios representantes con el mismo documento para la misma persona jurídica en el tipo de intervención seleccionado.',
	documentoRequired: 'Falta documentación por aportar',
	sujetoRequired: 'Falta sujeto por aportar'
};

export const errorDocMaxSize = (size: string | number) => `El peso máximo de los documentos no puede superar los ${size}MB.`;

export const ERROR_TYPE = {
	required: 'required',
	documentoRequired: 'documento-required',
	sujetoRequired: 'sujeto-required',
	minInterviniente: 'min-interviniente',
	uniqueDocument: 'unique-document',
	duplicatedFisica: 'duplicated-fisico',
	duplicatedJuridico: 'duplicated-juridico',
	duplicatedRepresentante: 'duplicated-representante',
};

export default ERROR_MESSAGE;
